export interface ClientNavItem {
    label: string
    icon: string
    routerLink: string
    showOnDesktop: boolean
    showOnMobile: boolean
}

export const CLIENT_NAV_ITEMS: ClientNavItem[] = [
    {
        label: 'Home',
        icon: 'pi-home',
        routerLink: '/dashboard/home/client',
        showOnDesktop: true,
        showOnMobile: true,
    },
    {
        label: 'Shops',
        icon: 'pi-building',
        routerLink: '/dashboard/client/shops',
        showOnDesktop: true,
        showOnMobile: true,
    },
    {
        label: 'Book Appointment',
        icon: 'pi-calendar-plus',
        routerLink: '/dashboard/client/book-appointment',
        showOnDesktop: true,
        showOnMobile: false,
    },
    {
        label: 'Appointments',
        icon: 'pi-calendar',
        routerLink: '/dashboard/client/my-appointments',
        showOnDesktop: true,
        showOnMobile: true,
    },
    {
        label: 'Favorites',
        icon: 'pi-heart',
        routerLink: '/dashboard/client/favorites',
        showOnDesktop: true,
        showOnMobile: true,
    },
    {
        label: 'Offers',
        icon: 'pi-tag',
        routerLink: '/dashboard/client/offers',
        showOnDesktop: true,
        showOnMobile: false,
    },
    {
        label: 'Hairstyles',
        icon: 'pi-image',
        routerLink: '/dashboard/client/hairstyles',
        showOnDesktop: true,
        showOnMobile: false,
    },
    {
        label: 'Reviews',
        icon: 'pi-comment',
        routerLink: '/dashboard/client/reviews',
        showOnDesktop: true,
        showOnMobile: false,
    },
    {
        label: 'Profile',
        icon: 'pi-user',
        routerLink: '/client/profile',
        showOnDesktop: true,
        showOnMobile: true,
    },
    {
        label: 'Settings',
        icon: 'pi-cog',
        routerLink: '/dashboard/client/settings',
        showOnDesktop: true,
        showOnMobile: false,
    },
]

export const mobileNavItems = () =>
    CLIENT_NAV_ITEMS.filter((i) => i.showOnMobile)
export const desktopNavItems = () =>
    CLIENT_NAV_ITEMS.filter((i) => i.showOnDesktop)

export const getClientPageTitle = (url: string): string => {
    const path = url.split('?')[0]
    const match = CLIENT_NAV_ITEMS.find((item) => item.routerLink === path)
    if (match) return match.label
    if (path.startsWith('/dashboard/client/shops')) return 'Shops'
    if (path.startsWith('/dashboard/organization')) return 'Organization'
    return 'Home'
}
